import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/help.svg';

export const IconHelp = createIconComponent(Icon);
